/* rev:2026-09-22-case-gallery-v4 */
/**
 * Wonderneath PDP gallery filter.
 * Dawn hide_variants renders: 1 featured (selected variant) + all non-variant extras.
 *
 * Case (body.wn-case-pdp): extras alt "WN|{angle|breakout|dual}|models|Glossy|Matte"
 * Color (any product PDP): extras/featured alt "WN|color|Black" (or silver/gold/White…)
 *   → hide slides whose WN|color| value ≠ selected Color option.
 */
(function () {
  function isCasePdp() {
    return document.body.classList.contains('wn-case-pdp');
  }

  function isProductPdp() {
    return document.body.classList.contains('template-product') ||
      document.body.classList.contains('wn-pdp');
  }

  function selectedOptions() {
    let size = '';
    let surface = 'Glossy';
    let color = '';
    document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
      const legend = ((fs.querySelector('legend') || {}).textContent || '').toLowerCase();
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      if (legend.indexOf('size') !== -1 || legend.indexOf('model') !== -1 || legend.indexOf('iphone') !== -1) size = checked.value;
      if (legend.indexOf('surface') !== -1 || legend.indexOf('finish') !== -1) surface = checked.value;
      if (legend.indexOf('color') !== -1 || legend.indexOf('colour') !== -1 || legend.indexOf('frame') !== -1) color = checked.value;
    });
    // Fallback: select dropdowns
    document.querySelectorAll('variant-selects select').forEach(function (sel) {
      const name = ((sel.getAttribute('name') || sel.getAttribute('data-option') || '') + ' ' +
        ((sel.previousElementSibling || {}).textContent || '')).toLowerCase();
      if (!sel.value) return;
      if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1 || name.indexOf('frame') !== -1) color = sel.value;
      if (name.indexOf('size') !== -1 || name.indexOf('model') !== -1 || name.indexOf('iphone') !== -1) size = sel.value;
      if (name.indexOf('surface') !== -1 || name.indexOf('finish') !== -1) surface = sel.value;
    });
    return { size: size, surface: surface, color: color };
  }

  function parseWnAlt(alt) {
    if (!alt || alt.indexOf('WN|') !== 0) return null;
    const parts = alt.split('|');
    if (parts.length < 2) return null;
    const kind = (parts[1] || '').trim();
    if (kind === 'color' && parts.length >= 3) {
      return { kind: 'color', color: parts[2].trim() };
    }
    if (parts.length < 4) return null;
    return {
      kind: kind,
      models: parts[2].split(',').map(function (s) { return s.trim(); }).filter(Boolean),
      finish: parts[3].trim(),
    };
  }

  function mediaAlt(el) {
    const img = el.querySelector('img');
    return (img && (img.getAttribute('alt') || img.alt)) || '';
  }

  function colorsMatch(a, b) {
    if (!a || !b) return false;
    return a.trim().toLowerCase() === b.trim().toLowerCase();
  }

  function applyFilter() {
    if (!isProductPdp()) return;
    const opts = selectedOptions();
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('.product__media-item');
    const thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    let firstVisible = null;
    let visibleCount = 0;
    const caseMode = isCasePdp();

    slides.forEach(function (slide) {
      const alt = mediaAlt(slide);
      const wn = parseWnAlt(alt);
      var show = true;
      if (wn && wn.kind === 'color') {
        // Color-tagged media: only show when Color option matches
        if (opts.color) {
          show = colorsMatch(wn.color, opts.color);
        }
      } else if (caseMode && wn) {
        if (!opts.size) {
          show = true;
        } else {
          show = wn.models.indexOf(opts.size) !== -1 && wn.finish === opts.surface;
        }
      } else {
        // Featured / non-WN — Dawn already swapped featured among variants
        show = true;
      }
      slide.classList.toggle('wn-gallery-hide', !show);
      if (show) {
        visibleCount += 1;
        if (!firstVisible) firstVisible = slide;
      }
    });

    thumbs.forEach(function (thumb) {
      const target = thumb.getAttribute('data-target');
      const slide = target
        ? gallery.querySelector('.product__media-item[data-media-id="' + target + '"]')
        : null;
      // Also filter thumbs that aren't in slides (other-variant featured thumbs)
      var hide;
      if (slide) {
        hide = slide.classList.contains('wn-gallery-hide');
      } else {
        const alt = mediaAlt(thumb);
        const wn = parseWnAlt(alt);
        if (wn && wn.kind === 'color' && opts.color) {
          hide = !colorsMatch(wn.color, opts.color);
        } else if (caseMode && wn && opts.size) {
          hide = !(wn.models.indexOf(opts.size) !== -1 && wn.finish === opts.surface);
        } else {
          hide = true; // orphan thumb with no slide — hide
        }
      }
      thumb.classList.toggle('wn-gallery-hide', hide);
    });

    if (firstVisible) {
      var active = gallery.querySelector('.product__media-item.is-active');
      var activate = firstVisible;
      if (active && !active.classList.contains('wn-gallery-hide')) {
        activate = active;
      }
      const mediaId = activate.getAttribute('data-media-id');
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s === activate);
      });
      thumbs.forEach(function (t) {
        const on = t.getAttribute('data-target') === mediaId && !t.classList.contains('wn-gallery-hide');
        const btn = t.querySelector('[aria-current], button, .thumbnail');
        if (btn) btn.setAttribute('aria-current', on ? 'true' : 'false');
      });
      // Only force Dawn media switch when active slide was hidden (variant change)
      if (activate === firstVisible && (!active || active.classList.contains('wn-gallery-hide'))) {
        if (typeof gallery.setActiveMedia === 'function') {
          try { gallery.setActiveMedia(mediaId, false); } catch (e) {}
        }
      }
    }

    gallery.setAttribute('data-wn-visible', String(visibleCount));

    // Lightbox modal
    document.querySelectorAll('product-modal .product-media-modal__content img, .product-media-modal__content img').forEach(function (img) {
      const wrap = img.closest('[id^="GalleryViewer"], li, .product-media-modal__content > *') || img.parentElement;
      const alt = img.getAttribute('alt') || img.alt || '';
      const wn = parseWnAlt(alt);
      var show = true;
      if (wn && wn.kind === 'color') {
        if (opts.color) show = colorsMatch(wn.color, opts.color);
      } else if (caseMode && wn) {
        show = wn.models.indexOf(opts.size) !== -1 && wn.finish === opts.surface;
      } else if (caseMode && alt && alt.indexOf('/') !== -1) {
        var expect = opts.size + ' / ' + opts.surface;
        show = alt.trim() === expect;
      }
      if (wrap) wrap.classList.toggle('wn-gallery-hide', !show);
      img.classList.toggle('wn-gallery-hide', !show);
    });
  }

  function schedule() {
    applyFilter();
    setTimeout(applyFilter, 60);
    setTimeout(applyFilter, 250);
    setTimeout(applyFilter, 600);
  }

  function bind() {
    if (!isProductPdp()) return;
    schedule();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && (
        e.target.matches('variant-selects input[type="radio"]') ||
        e.target.matches('variant-selects select')
      )) {
        schedule();
      }
    });
    document.addEventListener('variant:change', schedule);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.variantChange, schedule); } catch (e) {}
    }
    const info = document.querySelector('product-info');
    if (info && typeof MutationObserver !== 'undefined') {
      const mo = new MutationObserver(function () { schedule(); });
      mo.observe(info, { childList: true, subtree: true });
    }
    const gallery = document.querySelector('media-gallery');
    if (gallery && typeof MutationObserver !== 'undefined') {
      const mo2 = new MutationObserver(function () { schedule(); });
      mo2.observe(gallery, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
